import base from './base'
import { addErrorNotification } from '../utils/notifications'

export const getDepartments = () => base.get('/department')
  .then(res => res.data)
  .catch(() => addErrorNotification('Unable to load <strong>Departments</strong>'))




// WEBPACK FOOTER //
// ./src/services/departments.js